module.exports = __webpack_public_path__ + "img/img-6aff86.jpg";